import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Helper //

export const getModule = (fullPath) => {
  const rawPath = typeof fullPath === 'string' && fullPath
    ? fullPath
    : typeof window !== 'undefined'
      ? window.location.pathname
      : '';

  const cleanPath = rawPath.split('?')[0].split('#')[0];

  const matchWithSlug = cleanPath.match(/^\/hospitals\/[^/]+\/([^/]+)/);
  if (matchWithSlug) return matchWithSlug[1];

  const fallback = cleanPath.match(/^\/([^/]+)/);
  const matched = fallback ? fallback[1] : '';

  return matched === 'hospitals' ? '' : matched;
};

export const getSlug = (fullPath) => {
  const rawPath = typeof fullPath === 'string' && fullPath
    ? fullPath
    : typeof window !== 'undefined'
      ? window.location.pathname
      : '';

  const cleanPath = rawPath.split('?')[0].split('#')[0];
  const match = cleanPath.match(/^\/hospitals\/([^/]+)/);

  return match ? match[1] : '';
};

// Middleware //

export const SlugComponentGuard = ({ children }) => {
  const path = typeof window !== 'undefined' ? window.location.pathname : '';
  const alreadyInHospital = /^\/hospitals\/[^/]+/.test(path);
  const [ready, setReady] = useState(alreadyInHospital);

  useEffect(() => {
    if (ready) return undefined;

    const slugId = getSlug();
    const currentPath = window.location.pathname;
    const isAlreadyInHospital = /^\/hospitals\/[^/]+/.test(currentPath);

    if (slugId && !isAlreadyInHospital) {
      const newPath = currentPath.startsWith('/') ? currentPath : `/${currentPath}`;
      window.location.replace(`/hospitals/${slugId}${newPath}`);
      return undefined;
    }

    setReady(true);
    return undefined;
  }, [ready]);

  if (!ready) return null;

  return <>{children}</>;
};

//

export const getPathWithSlug = (path = '') => {
  const slugId = getSlug();
  if (slugId) {
    const cleanedPath = path.startsWith('/') ? path.slice(1) : path;
    return `/hospitals/${slugId}/${cleanedPath}`;
  }
  return path;
};

export const useNavigateWithSlugHook = () => {
  const navigate = useNavigate();

  return (path, options = {}) => {
    const finalPath = getPathWithSlug(path);
    navigate(finalPath, options);
  };
};

export const setHrefWithSlugHook = (path = '') => {
  const finalPath = getPathWithSlug(path);
  window.location.href = finalPath;
};
